// let apiBaseUrl = 'https://backendrodeo.insiderodeo.com/api/v1/';
// let socketUrl = 'https://backendrodeo.insiderodeo.com:6672';
let apiBaseUrl = "https://backendrodeo.glohtesting.com/api/v1/";
let socketUrl = "https://backendrodeo.glohtesting.com:6682";

let cloudFrontUrl = "";

const appStage = process.env.REACT_APP_STAGE;

if (appStage == "dev") {
   apiBaseUrl = "https://insiderodeo-api.stage.tetonridge.io/api/v1/";
  socketUrl = "https://pfr-socket.stage.tetonridge.io/";
  cloudFrontUrl = "https://stage-insiderodeo-api.s3.amazonaws.com/assets/share_image/";
}  else if (appStage === "stage") {
  apiBaseUrl = "https://insiderodeo-api.stage.tetonridge.io/api/v1/";
  socketUrl = "https://pfr-socket.stage.tetonridge.io/";
  cloudFrontUrl = "https://stage-insiderodeo-api.s3.amazonaws.com/assets/share_image/";
} else if (appStage == "uat") {
  apiBaseUrl = "https://backendrodeo.insiderodeo.com/api/v1/";
  socketUrl = "https://backendrodeo.insiderodeo.com:6672";
} else if (appStage == "prod") {
  apiBaseUrl = "https://api.insiderodeo.com/api/v1/";
  socketUrl = "https://ws.insiderodeo.com/";
  cloudFrontUrl = "https://d2mkr7tc1e0pje.cloudfront.net/assets/share_image/";
}
export const SOCKET_TRANSPORTS = ['websocket', 'polling']; // WebSocket-first, polling fallback
export const API_BASE_URL = apiBaseUrl;
export const SOCKETURL = socketUrl;
export const CLOUDFRONT_URL = cloudFrontUrl;
